import React from "react"
import { Box, Collapse } from "@material-ui/core"
import { Blockquote } from "."
import { Icon } from ".."

const HasActiveJobsChangedBlockquote = ({ show = false, subject = "process", count, mb = 3 }) => (
  <Collapse in={show}>
    <Box mb={mb}>
      <Blockquote
        icon={<Icon name="warning" />}
        title={`Active job${count > 1 ? "s" : ""}`}
        body={
          count > 1
            ? `This ${subject} has ${count} active jobs running today. Changes made will only take affect from the next scheduled instance. If you need to, you can edit todays active jobs from the Active Jobs area.`
            : `This ${subject} has an active job running today. Changes made will only take affect from the next scheduled instance. If you need to, you can edit todays active job from the Active Jobs area.`
        }
        color="warning"
      />
    </Box>
  </Collapse>
)

export { HasActiveJobsChangedBlockquote }
